import React from 'react'

import CompetitiveIntelligenceNavigation from '../Navigation'
import { Eyebrow, Header, Intro, Subtitle, Title } from './styled'

export default function CompetitiveIntelligenceHeader({ description, eyebrow, t, title }) {
    return (
        <>
            <Header>
                <Intro>
                    <Eyebrow>{eyebrow}</Eyebrow>
                    <Title>{title}</Title>
                    <Subtitle>{description}</Subtitle>
                </Intro>
            </Header>
            <CompetitiveIntelligenceNavigation t={t} />
        </>
    )
}
